export function searchSlide() {
    const searchSlideOpen = document.getElementById('searchSlide_open');
    const searchSlideClose = document.getElementById('searchSlide_close');
    const searchSlide = document.getElementById('searchSlide');
    const searchSlideBg = document.getElementById('searchSlide_bg');

    function openSlide() {
        searchSlide.classList.add('open');
        searchSlideBg.style.setProperty('display', 'block')

        setTimeout(function () {
            searchSlideBg.classList.add('open');
        })
    }

    function closeSlide() {
        searchSlide.classList.remove('open');
        searchSlideBg.classList.remove('open');

        setTimeout(function () {
            searchSlideBg.style.setProperty('display', null)

        }, 300)
    }

    searchSlideOpen.addEventListener('click', function () {
        openSlide();
    })

    searchSlideClose.addEventListener('click', function () {
        closeSlide();
    })

    searchSlideBg.addEventListener('click', function () {
        closeSlide();
    })

}